export const schools = [
  {
    key: "r1",
    value:
      "CPIA Centro Provinciale Istruzione Adulti &quot;Alberto Manzi&quot;",
  },
  { key: "r83", value: "Collegio Vescovile Pio X" },
  { key: "r2", value: "I.C. CASTELLO DI GODEGO" },
  {
    key: "r3",
    value:
      "I.C. con indirizzo musicale Vittorio Veneto 2 &quot;Zanzotto&quot; ",
  },
  { key: "r4", value: "I.C. di &quot;Nievo&quot; Cordignano" },
  { key: "r5", value: "I.C. di Altivole" },
  { key: "r6", value: "I.C. di Asolo " },
  { key: "r7", value: "I.C. di Breda di Piave" },
  { key: "r8", value: "I.C. di Caerano San Marco" },
  { key: "r9", value: "I.C. di Cappella Maggiore" },
  { key: "r10", value: "I.C. di Carbonera" },
  { key: "r11", value: "I.C. di Casale sul Sile" },
  { key: "r12", value: "I.C. di Casier" },
  { key: "r13", value: "I.C. di Castelfranco Veneto 1° &quot;Giorgione&quot;" },
  { key: "r14", value: "I.C. di Castelfranco Veneto 2° &quot;Sarto&quot;" },
  { key: "r15", value: "I.C. di Codognè" },
  { key: "r16", value: "I.C. di Conegliano 1 &quot;Grava&quot; " },
  { key: "r17", value: "I.C. di Conegliano 2° &quot;Cima&quot;" },
  { key: "r18", value: "I.C. di Conegliano 3° &quot;Brustolon&quot; " },
  { key: "r19", value: "I.C. di Cornuda" },
  { key: "r20", value: "I.C. di Farra di Soligo" },
  { key: "r21", value: "I.C. di Follina e Tarzo" },
  { key: "r22", value: "I.C. di Gaiarine" },
  { key: "r23", value: "I.C. di Giavera del Montello" },
  { key: "r24", value: "I.C. di Gorgo al Monticano" },
  { key: "r25", value: "I.C. di Istrana " },
  { key: "r26", value: "I.C. di Loria e Castello di Godego " },
  { key: "r27", value: "I.C. di Mareno di Piave e Vazzola" },
  { key: "r28", value: "I.C. di Maserada sul Piave" },
  { key: "r29", value: "I.C. di Mogliano Veneto 1 " },
  { key: "r30", value: "I.C. di Mogliano Veneto 2° &quot;Minerbi&quot;" },
  {
    key: "r31",
    value: "I.C. di Montebelluna 1° &quot;Rita Levi Montalcini&quot; ",
  },
  { key: "r32", value: "I.C. di Montebelluna 2° " },
  { key: "r33", value: "I.C. di Motta di Livenza" },
  { key: "r34", value: "I.C. di Oderzo" },
  { key: "r35", value: "I.C. di Paese" },
  { key: "r36", value: "I.C. di Pederobba" },
  { key: "r37", value: "I.C. di Pieve del Grappa" },
  { key: "r38", value: "I.C. di Pieve di Soligo" },
  { key: "r39", value: "I.C. di Ponte di Piave" },
  { key: "r40", value: "I.C. di Ponzano Veneto" },
  { key: "r41", value: "I.C. di Preganziol" },
  { key: "r42", value: "I.C. di Quinto di Treviso e Morgano " },
  { key: "r43", value: "I.C. di Resana" },
  { key: "r44", value: "I.C. di Riese Pio X" },
  { key: "r45", value: "I.C. di Roncade" },
  { key: "r46", value: "I.C. di Salgareda" },
  { key: "r47", value: "I.C. di San Biagio di Callalta" },
  { key: "r48", value: "I.C. di San Fior" },
  { key: "r49", value: "I.C. di San Polo di Piave " },
  { key: "r50", value: "I.C. di San Vendemiano" },
  { key: "r51", value: "I.C. di San Zenone degli Ezzelini + Fonte " },
  { key: "r52", value: "I.C. di Santa Lucia di Piave" },
  { key: "r53", value: "I.C. di Sernaglia della Battaglia" },
  { key: "r54", value: "I.C. di Silea" },
  { key: "r55", value: "I.C. di Spresiano" },
  { key: "r56", value: "I.C. di Susegana" },
  { key: "r57", value: "I.C. di Trevignano" },
  { key: "r58", value: "I.C. di Treviso 1 &quot;Martini&quot;" },
  { key: "r59", value: "I.C. di Treviso 2 &quot;Serena&quot;" },
  { key: "r60", value: "I.C. di Treviso 3 &quot;Felissent”" },
  { key: "r61", value: "I.C. di Treviso 4 &quot;Stefanini&quot; " },
  { key: "r62", value: "I.C. di Treviso 5 &quot;Coletti&quot; " },
  { key: "r63", value: "I.C. di Valdobbiadene " },
  { key: "r64", value: "I.C. di Vedelago" },
  { key: "r65", value: "I.C. di Villorba e Povegliano" },
  { key: "r66", value: "I.C. di Vittorio Veneto 1&quot;Da Ponte&quot;" },
  { key: "r67", value: "I.C. di Volpago del Montello" },
  { key: "r68", value: "I.C. di Zero Branco" },
  { key: "r82", value: "Istituto Canossiano Treviso" },
  { key: "r69", value: "SMS &quot;AMALTEO&quot; ODERZO-S.C." },
  { key: "r70", value: "SMS &quot;CASTELLER&quot;PAESE-SEDE CENT." },
  { key: "r71", value: "SMS &quot;E.REATTO&quot; VALDOBBIADENE-S.C" },
  { key: "r72", value: "SMS &quot;L.COLETTI&quot; TREVISO-S.C.-" },
  { key: "r73", value: "SMS &quot;MANZONI&quot; VILLORBA-S.C." },
  { key: "r74", value: "SMS &quot;SERENA&quot; TREVISO-SEDE CENTR.-" },
  { key: "r75", value: "SMS &quot;STEFANINI&quot; TREVISO-S.C." },
  { key: "r76", value: "SMS FONTE-SEDE CENTRALE" },
  { key: "r77", value: "SMS GIRARDINI MOTTA-SEDE CENT." },
  { key: "r78", value: "SMS MARTIRI D.LIB.RONCADE-S.C." },
  { key: "r79", value: "SMS MONTEBELLUNA-SEDE CENT.-" },
  { key: "r80", value: "SMS&quot; T.DAL MONTE&quot;MOGLIANO-S.C." },
  { key: "r81", value: "SMS&quot;GRAVA&quot;CONEGLIANO-S.C." },
  { key: "r99", value: "Altro" },
];
